const choices = {
    callAdvisorToAct: 'J\'appelle mon conseiller pour prendre une décision réfléchie',
    sellEverything: 'Je vends tout',
    waitsWithoutCallingAdvisor: 'J\'attends sans appeler mon conseiller',
};

export default choices;
